import { render, staticRenderFns } from "./EditedNotification.vue?vue&type=template&id=3dd1c062&"
import script from "./EditedNotification.vue?vue&type=script&lang=ts&"
export * from "./EditedNotification.vue?vue&type=script&lang=ts&"
import style0 from "./EditedNotification.vue?vue&type=style&index=0&id=3dd1c062&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports